import { Component } from '@angular/core';

import { ConfigService } from 'app/core/services/config.service';
import { Observable } from 'rxjs/Observable';
import {SolarEmailService} from '../service/emails.service';

@Component({
    selector: 'itpx-emails',
    templateUrl: './emails.component.html',
    styleUrls: [ './emails.component.css' ]
})
export class SolarEmailsComponent {
    private url: string;
    private errorMessage: string;
    private detailsRoute: string = '/organization/communications/emails/{{key}}/details';
    private fields: Array<any> = [
        {
            title: 'From',
            name: 'from',
            sortable: true
        }, {
            title: 'To',
            name: 'to',
            sortable: true
        },
        {
            title: 'Subject',
            name: 'subject',
            sortable: true,
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        },
        {
            title: 'Sent on',
            name: 'createdAt',
            sortable: true,
            config: {
                type: 'date'
            }
        }
    ];

    private handleError(err: any) {
        err = err.json();
        let message = (err.message) ? err.message : 'Server error';
        console.error(message);
        return Observable.throw(message);
    }

    constructor( private EmailService: SolarEmailService, private configService: ConfigService ) {
        this.url = configService.get('server').url + configService.get('endpoints').tm.email.list.api;
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/communication/emails/components/emails.component.ts